import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from 'semantic-ui-react';

function NpwpApproveConfirmationModal({
  shown,
  onClose,
  onConfirm,
  businessOrOwnerName,
  isLoading,
}) {
  const onModalClosing = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal open={shown} onClose={onModalClosing}>
      <ModalHeader>Confirm Approve NPWP</ModalHeader>
      <ModalContent>
        <p>
          Are you sure to Approve <strong>{businessOrOwnerName}</strong> ?
        </p>
      </ModalContent>
      <ModalActions>
        <Button onClick={onModalClosing} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          positive
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
}

NpwpApproveConfirmationModal.propTypes = {
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  businessOrOwnerName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default NpwpApproveConfirmationModal;
